'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var lc_menu = [{
  name: "MISSION",
  link: "https://www.lanl.gov/mission/index.php",
  lc_page_groups: []
}, {
  name: "SCIENCE & INNOVATION",
  link: "https://www.lanl.gov/science-innovation/index.php",
  lc_page_groups: [{
    name: "Science & Innovation",
    link: "https://www.lanl.gov/science-innovation/index.php",
    lc_pages: [{
      name: "Science Highlights",
      link: "https://www.lanl.gov/science-innovation/index.php"
    }, {
      name: "Science Briefs",
      link: "https://www.lanl.gov/discover/science-briefs/index.php"
    }, {
      name: "Science Facilities",
      link: "https://www.lanl.gov/science-innovation/science-facilities/index.php"
    }, {
      name: "Capability Pillars",
      link: "https://www.lanl.gov/science-innovation/pillars/index.php"
    }, {
      name: "Science Videos",
      link: "https://www.lanl.gov/science-innovation/science-videos1.php"
    }, {
      name: "Lab Organizations",
      link: "https://www.lanl.gov/org/index.php"
    }, {
      name: "Research Library",
      link: "http://www.lanl.gov/library/index.php"
    }]
  }, {
    name: "Science Programs",
    link: "https://www.lanl.gov/science-innovation/science-programs/index.php",
    lc_pages: [{
      name: "Applied Energy Programs",
      link: "https://www.lanl.gov/science-innovation/science-programs/applied-energy-programs/index.php"
    }, {
      name: "Civilian Nuclear Energy Programs",
      link: "https://www.lanl.gov/science-innovation/science-programs/civilian-nuclear-programs/index.php"
    }, {
      name: "Laboratory Directed Research & Development (LDRD)",
      link: "https://www.lanl.gov/science-innovation/science-programs/ldrd/index.php"
    }, {
      name: "National Security Education Center (NSEC)",
      link: "https://www.lanl.gov/projects//national-security-education-center/index.php"
    }, {
      name: "Office of Science Programs",
      link: "https://www.lanl.gov/science-innovation/science-programs/office-of-science-programs/index.php"
    }]
  }]
}, {
  name: "COLLABORATION",
  link: "https://www.lanl.gov/collaboration/index.php",
  lc_page_groups: [{
    name: "User Facilities",
    link: "https://www.lanl.gov/collaboration/user-facilities/index.php",
    lc_pages: [{
      name: "CINT",
      link: "http://cint.lanl.gov/index.php"
    }, {
      name: "LANSCE",
      link: "http://lansce.lanl.gov/"
    }, {
      name: "NHMFL",
      link: "https://nationalmaglab.org/user-facilities/pulsed-field-facility"
    }, {
      name: "Biosurveillance Gateway",
      link: "https://www.lanl.gov/projects//biosurveillance-gateway/index.php"
    }, {
      name: "Pathogen Databases",
      link: "https://www.lanl.gov/collaboration/pathogen-database/index.php"
    }]
  }, {
    name: "Feynman Center For Innovation",
    link: "https://www.lanl.gov/projects//feynman-center/index.shtml",
    lc_pages: [{
      name: "LACED",
      link: "https://www.lanl.gov/projects//explosives-detection/index.php"
    }, {
      name: "Exascale Computing Project",
      link: "https://www.lanl.gov/projects//exascale-computing-project/index.php"
    }, {
      name: "FUTURE",
      link: "https://www.lanl.gov/projects//future/index.php"
    }]
  }, {
    name: "National Security Education Center (NSEC)",
    link: "https://www.lanl.gov/projects//national-security-education-center/index.php",
    lc_pages: [{
      name: "Center for Nonlinear Studies",
      link: "https://www.lanl.gov/projects//national-security-education-center/center-nonlinear-studies/index.php"
    }, {
      name: "Engineering Institute",
      link: "https://www.lanl.gov/projects//national-security-education-center/engineering/index.php"
    }, {
      name: "Information Science & Technology Institute",
      link: "https://www.lanl.gov/projects//national-security-education-center/information-science-technology/index.php"
    }, {
      name: "Center for Space and Earth Science",
      link: "https://www.lanl.gov/projects//national-security-education-center/space-earth-center/index.php"
    }, {
      name: "Institute for Materials Science",
      link: "https://www.lanl.gov/projects//national-security-education-center/institute-for-materials-science/index.php"
    }, {
      name: "Seaborg Institute",
      link: "https://www.lanl.gov/projects//national-security-education-center/seaborg/index.php"
    }, {
      name: "Fellows",
      link: "https://www.lanl.gov/collaboration/fellows/index.php"
    }]
  }, {
    name: "Research Opportunities",
    link: "https://www.lanl.gov/collaboration/research-opportunities/index.php",
    lc_pages: [{
      name: "Service Academies and ROTC Research Associates",
      link: "https://www.lanl.gov/collaboration/internships/service-academy-research-associates/index.php"
    }, {
      name: "Strategic Analyses and Assessments Office",
      link: "https://www.lanl.gov/projects/strategic-analyses-and-assessments/index.php"
    }]
  }]
}, {
  name: "COMMUNITY",
  link: "https://www.lanl.gov/community/index.php",
  lc_page_groups: [{
    name: "Community Commitment",
    link: "https://www.lanl.gov/community/index.php",
    lc_pages: [{
      name: "Giving campaigns, drives",
      link: "https://www.lanl.gov/community/giving/index.php"
    }, {
      name: "Economic development",
      link: "https://www.lanl.gov/community/economic-development.php"
    }, {
      name: "Grants and Sponsorships",
      link: "https://www.lanl.gov/community/grantapplication.php"
    }]
  }, {
    name: "Stem Education",
    link: "https://www.lanl.gov/community/education/index.php",
    lc_pages: [{
      name: "Teachers (K-12)",
      link: "https://www.lanl.gov/community/education/stem-education-programs.php"
    }, {
      name: "Students (K-12)",
      link: "https://www.lanl.gov/community/education/teacher-resources/index.php"
    }, {
      name: "Higher education",
      link: "https://www.lanl.gov/community/education/higher-education-resources/index.php"
    }, {
      name: "Regional education partners",
      link: "https://www.lanl.gov/community/education/regional-partners/index.php"
    }, {
      name: "NM Governor's STEM Challenge",
      link: "https://www.lanl.gov/community/education/stem-challenge/index.php"
    }]
  }, {
    name: "Internal",
    link: "https://www.lanl.gov/community/visitors/index.php",
    lc_pages: [{
      name: "Badging, Badge Office",
      link: "https://www.lanl.gov/community/visitors/badging/index.php"
    }, {
      name: "Bradbury Science Museum",
      link: "https://www.lanl.gov/community/visitors/bradbury-science-museum.php"
    }, {
      name: "Housing",
      link: "https://www.lanl.gov/community/visitors/housing.php"
    }, {
      name: "Maps",
      link: "https://www.lanl.gov/resources/maps.php"
    }]
  }, {
    name: "Related Resources",
    link: null,
    lc_pages: [{
      name: "Calendar",
      link: "http://www.lanl.gov/calendar/"
    }, {
      name: "Community Connections",
      link: "https://discover.lanl.gov/publications/connections"
    }, {
      name: "Community feature stories",
      link: "https://www.lanl.gov/community/stories/index.php"
    }]
  }]
}, {
  name: "ENVIRONMENT",
  link: "https://www.lanl.gov/environment/index.php",
  lc_page_groups: [{
    name: "Environmental Protection",
    link: "https://www.lanl.gov/environment/protection/index.php",
    lc_pages: [{
      name: "What we monitor and why",
      link: "https://www.lanl.gov/environment/protection/monitoring/index.php"
    }, {
      name: "Cultural preservation",
      link: "https://www.lanl.gov/environment/protection/cultural-preservation/index.php"
    }, {
      name: "Taking care of our trails",
      link: "https://www.lanl.gov/environment/protection/trails/index.php"
    }, {
      name: "Obeying environmental laws",
      link: "https://www.lanl.gov/environment/protection/compliance/index.php"
    }, {
      name: "Protecting Wildlife",
      link: "https://www.lanl.gov/environment/protection/wildlife-protection/index.php"
    }]
  }, {
    name: "Environmental Sustainability",
    link: "https://sustainability.lanl.gov/",
    lc_pages: [{
      name: "Sustainability goals",
      link: "https://sustainability.lanl.gov/goals-and-progress"
    }, {
      name: "Recycling",
      link: "https://www.lanl.gov/environment/sustainability/recycling.php"
    }, {
      name: "Green purchasing",
      link: "https://www.lanl.gov/environment/sustainability/green-purchasing.php"
    }, {
      name: "Pollution prevention",
      link: "https://www.lanl.gov/environment/sustainability/pollution-prevention.php"
    }, {
      name: "Reusing water",
      link: "https://www.lanl.gov/environment/sustainability/water-reuse.php"
    }]
  }, {
    name: "Resources",
    link: null,
    lc_pages: [{
      name: "Environmental Management System",
      link: "https://www.lanl.gov/environment/protection/environmental-management-system.php"
    }, {
      name: "Feature stories",
      link: "https://www.lanl.gov/environment/stories/index.php"
    }, {
      name: "Public Reading Room",
      link: "https://www.lanl.gov/environment/public-reading-room.php"
    }]
  }]
}];
var lc_utility_menu = [{
  name: "Quick Links",
  lc_utility_item: [{
    name: "About",
    link: "https://www.lanl.gov/about/index.php"
  }, {
    name: "Badging",
    link: "https://www.lanl.gov/community/visitors/badging/index.php"
  }, {
    name: "Business",
    link: "https://www.lanl.gov/business/procurement-opportunities.php"
  }, {
    name: "Contacts",
    link: "https://www.lanl.gov/resources/contacts.php"
  }, {
    name: "Maps",
    link: "https://www.lanl.gov/resources/maps.php"
  }, {
    name: "Mission",
    link: "https://www.lanl.gov/mission/index.php"
  }, {
    name: "Museum",
    link: "https://www.lanl.gov/museum//index.php"
  }, {
    name: "Organizations",
    link: "https://www.lanl.gov/org/index.php"
  }, {
    name: "New Hires",
    link: "https://www.lanl.gov/careers/employees-retirees/new-hires/index.php"
  }, {
    name: "Publications",
    link: "https://www.lanl.gov/discover/publications/index.php"
  }, {
    name: "Research Library",
    link: "http://www.lanl.gov/library//index.php"
  }]
}];
var menu_articles_environment = [];
var menu_articles_community = [{
  card_image: {
    id: "5758ef52-d795-4dad-8485-3d34e0e0dc40",
    filename_disk: "5758ef52-d795-4dad-8485-3d34e0e0dc40.jpg",
    title: "2022-07-21",
    width: 700,
    height: 500
  },
  feature_image: null,
  news_type: {
    slug: "stories"
  },
  slug: "0721-n2mis",
  title: "Northern New Mexico Integrated Security LLC awarded five-year subcontract to provide protective services at Los Alamos",
  status: "published"
}, {
  card_image: {
    id: "df66fa34-f029-4868-819f-3f9aa6828366",
    filename_disk: "df66fa34-f029-4868-819f-3f9aa6828366.jpg",
    title: "Inclusion 2731339 960 720",
    width: 960,
    height: 640
  },
  feature_image: {
    id: "271ab2fe-d623-4723-8500-03b8e061aed2",
    filename_disk: "271ab2fe-d623-4723-8500-03b8e061aed2.jpg",
    title: "Inclusion 2731339 960 720",
    width: 960,
    height: 640
  },
  news_type: {
    slug: "stories"
  },
  slug: "0718-disability-celebration-month",
  title: "Los Alamos National Laboratory holds first-ever Disability Celebration Month",
  status: "published"
}, {
  card_image: {
    id: "1e179d2a-0450-4644-b785-29f2576cfbb9",
    filename_disk: "1e179d2a-0450-4644-b785-29f2576cfbb9.jpg",
    title: "2022-07-14",
    width: 664,
    height: 450
  },
  feature_image: {
    id: "6dc26a40-6368-4ba2-b1aa-1901ddd32d1f",
    filename_disk: "6dc26a40-6368-4ba2-b1aa-1901ddd32d1f.jpg",
    title: "2022-07-14 Publication Feature with Title@2x@2x",
    width: 1200,
    height: 500
  },
  news_type: {
    slug: "stories"
  },
  slug: "0714-sciencefest",
  title: "Experts from Manhattan Project National Historical Park join the fun at Los Alamos ScienceFest Discovery Day July 16",
  status: "published"
}];
var menu_articles_science = [{
  card_image: null,
  feature_image: {
    id: "e25db7ab-8216-4c95-b81a-f6b1e8849c08",
    filename_disk: "e25db7ab-8216-4c95-b81a-f6b1e8849c08.png",
    title: "2022-06-16",
    width: 941,
    height: 630
  },
  news_type: {
    slug: "stories"
  },
  slug: "0616-best-experiment-results",
  title: "Experiment results confirm anomaly suggesting new physics possibility",
  status: "published"
}, {
  card_image: null,
  feature_image: {
    id: "88a40df4-5b73-412d-a835-771e9054a64b",
    filename_disk: "88a40df4-5b73-412d-a835-771e9054a64b.jpg",
    title: "2022-06-10",
    width: 1200,
    height: 797
  },
  news_type: {
    slug: "stories"
  },
  slug: "0610-lansce",
  title: "LANSCE: Unique capabilities for science and national security",
  status: "published"
}, {
  card_image: null,
  feature_image: {
    id: "afe53f0e-7b88-4afa-90d6-b3598230cfae",
    filename_disk: "afe53f0e-7b88-4afa-90d6-b3598230cfae.jpg",
    title: "2022-05-31",
    width: 1396,
    height: 754
  },
  news_type: {
    slug: "stories"
  },
  slug: "0531-tonga-eruption",
  title: "Tonga eruption drops data windfall for modeling atmospheric sound",
  status: "published"
}, {
  card_image: null,
  feature_image: {
    id: "17b47c66-4996-413f-a3cb-9256805cfed4",
    filename_disk: "17b47c66-4996-413f-a3cb-9256805cfed4.jpg",
    title: "2022-05-26 News Card@2x",
    width: 1400,
    height: 1120
  },
  news_type: {
    slug: "stories"
  },
  slug: "0526-quantum-chaos",
  title: "Finding coherence in quantum chaos",
  status: "published"
}, {
  card_image: null,
  feature_image: {
    id: "38d9f46b-fa6a-4a6a-9f14-625ede1aca99",
    filename_disk: "38d9f46b-fa6a-4a6a-9f14-625ede1aca99.jpg",
    title: "2022-05-11 Top News Card@2x",
    width: 1400,
    height: 1000
  },
  news_type: {
    slug: "stories"
  },
  slug: "0511-tsunamis",
  title: "New research could provide earlier warning of tsunamis",
  status: "published"
}, {
  card_image: {
    id: "dd1b742d-0b7b-4414-abc4-d09d3566b909",
    filename_disk: "dd1b742d-0b7b-4414-abc4-d09d3566b909.jpg",
    title: "2022-04-20 News Card@2x",
    width: 1400,
    height: 1120
  },
  feature_image: {
    id: "3145dca9-7075-4533-a6a4-ead2ff0e65ef",
    filename_disk: "3145dca9-7075-4533-a6a4-ead2ff0e65ef.jpg",
    title: "2022-04-21",
    width: 864,
    height: 576
  },
  news_type: {
    slug: "stories"
  },
  slug: "0421-wildland-fire-research",
  title: "Los Alamos National Laboratory, USGS partner to advance wildland-fire research",
  status: "published"
}];
var navData = {
  lc_menu: lc_menu,
  lc_utility_menu: lc_utility_menu,
  menu_articles_environment: menu_articles_environment,
  menu_articles_community: menu_articles_community,
  menu_articles_science: menu_articles_science
};
exports['default'] = navData;
exports.lc_menu = lc_menu;
exports.lc_utility_menu = lc_utility_menu;
exports.menu_articles_community = menu_articles_community;
exports.menu_articles_environment = menu_articles_environment;
exports.menu_articles_science = menu_articles_science;